
import { put, takeEvery } from "redux-saga/effects";

import { AUTH_RENEW_SESSION, AuthRenewSessionAction, setToken } from "../actions";
import { getStoredCredentials } from "../util";
import { refreshAccessToken, RefreshTokenReturn } from "./WebAuth";

export function* renewSession(action: AuthRenewSessionAction) {
    const currentCreds = getStoredCredentials();
    if (currentCreds && currentCreds.refreshToken) {
        const sessionResult: RefreshTokenReturn = yield refreshAccessToken({ refreshToken: currentCreds.refreshToken });

        yield put(setToken({
            accessToken: sessionResult.access_token,
            expiresInSeconds: sessionResult.expires_in,
            refreshToken: sessionResult.refresh_token
        }));
    }
}

export function* watchRenewSession() {
    yield takeEvery(AUTH_RENEW_SESSION, renewSession);
}
